import style from "./index.css";
import Head from "next/head";
import MiniFooter from "../../../components/MiniFooter";
import {
  GreenButtonDeep,
  GreenButtonSmall,
  OutlineButtonGray,
  OutlineButtonPlain,
  WhiteBgButton,
} from "../../../components/Button";
import ProductProvider, {
  useProductContext,
} from "../../../components/ProductProvider";


const srcBase = "/static/img/performance";



const Card = ({ imgSrc, text, subtext }) => {
  return (
    <div className="card-drive mb-3 pt-4 ">
      <div style={{ textAlign: "left" }}>
        <img src={imgSrc} className=" mb-4" alt="..." width={44} height={49} /></div>
      <div className="card-body">
        <h2 className="card-text">{text}</h2>
        <p className="card-subtext">{subtext}</p>
      </div>
    </div>
  );
};

const Page = () => {
  const { defaultOffer, loading } = useProductContext();
  return (
    <>
      <Head>
        <title className="next-head">
          Workflow Management | Gov ECMS - 1Gov
        </title>
        <meta
          name="description"
          content="Automate your workflow process with in 5 easy steps"
        />
        <link rel="canonical" href="#/products/performance" />
        <meta property="og:url" content="#/products/performance" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="performance" />
        <meta
          property="og:description"
          content="The performance is a flexible and fully integrated platform to the Business and Operation Support system for Service Fulfilment, Problem Handling and and systems ranging from complaint handling, task management to inventory request management"
        />
        <meta property="og:image:width" content="" />
        <meta property="og:image:height" content="" />
        <meta property="og:image" content="#/static/img/products/wfm1_11.png" />
        <meta name="og:image" content="#/static/img/products/wfm1_11.png" />
        <meta name="twitter:title" content="performance" />
        <meta
          name="twitter:description"
          content="The 1Gov ECMS (WFM) is a flexible and fully integrated platform to the Business and Operation Support system for Service Fulfilment, Problem Handling and and systems ranging from complaint handling, task management to inventory request management"
        />
        <meta
          property="twitter:image"
          content="#/static/img/products/wfm1_11.png"
        />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="" />
      </Head>

      <div className="hero-section">
        <div className="container">
          <div className="col-md-6">
            <h1 className="text-dark display-5 fw-bolder" >
              Track, Evaluate, and Manage Staff Performance. Tailored for Government MDAs
            </h1>
            <p className="hero-text">
              Discover the 1Gov Performance Management solution - your comprehensive tool for revolutionizing how government MDA managers and leaders track, assess, and enhance team performance.
            </p>
          </div>
          <div className="button-row">
            <GreenButtonDeep
              label="Sign up now →"
              className="cicod-btn-green-deep"
              link="/subscribe"
            />
            <OutlineButtonPlain
              label="Request a quote →"
              className="cicod-btn-green-deep"
              link="http://gbb.1gov.ng/webform/REQUEST%2520FOR%2520QUOTE"
            />
          </div>
        </div>

        <div className="img-bg"></div>
      </div>

      <section className="section-one container ">
        <div className="text-row ">
          <div className="border rounded-4 w-75 mx-auto position-relative" style={{ backgroundColor: 'rgba(204, 228, 255,0.1)' }}>
            <div
              className="text-cont text-center pt-4"
              data-aos="fade-left"
              data-aos-duration="1000"
            >
              <h2 className="fw-bold text-center text-dark w-75 mx-auto pt-4" style={{ fontSize: 34.28, color: '#21714B' }}>
                1Gov Performance Management - Flexible and Insightful tool for Government MDAs
              </h2>
              <p className="mb-4  w-75 mx-auto pb-4" style={{ fontSize: 18.95, }}>Performance Management leverages employee skills to reward performance. This can streamline your performance processes and drive growth.</p>
              <div className="position-absolute start-50 translate-middle" style={{ transform: 'translateX(-40%)' }}>
                <WhiteBgButton
                  label="Sign up now →"
                  className="cicod-btn-sm "
                  link="/subscribe"
                />
              </div>
            </div>
          </div>
          
        </div>
      </section>



      <section className="section-two">
        <div className="container ">
        <div
            className="text-cont mb-5 "
            data-aos="fade-left"
            data-aos-duration="1000"
          >
            <p className="fw-medium text-center text-dark w-50 mx-auto  " style={{ fontSize: 28, color: '#21714B',paddingBottom:40   }}>
              How Government Agencies can benefit from Performance Management
            </p>
          </div>
          <div className="cardContainer">
            <div className="card" >
              <div className="textCol" >
                <h2 style={{ color: '#1A191E', fontSize: 40, fontWeight: 500 }}>Promotion Management</h2>
                <p className=" pb-4" style={{ color: '#444444', fontSize: 14 }}>
                  With performance management, Government MDAs can manage the promotion of staff based on the outcomes of the appraisal process. With this, promotion will strictly be based on merit and would be fully automated.
                </p>
              </div>
              <div className="iconCol">
                <img
                  src={`${srcBase}/promotion.webp`}
                  className="img-resize img-fluid"
                  alt=""
                />
              </div>

            </div>
            <div className="card">
              <div className="iconCol">
                <img
                  src={`${srcBase}/data.webp`}
                  className="img-resize img-fluid"
                />
              </div>
              <div className="textCol">
                <h2 style={{ color: '#1A191E', fontSize: 40, fontWeight: 500 }}>Data Management</h2>
                <p className="pb-4" style={{ color: '#444444', fontSize: 14, lineHeight: '152%' }}>
                  Performance Management securely stores individual employee data such as benefits enrollment, role change, job re-classNameification, new hires, and updating events
                </p>
              </div>

            </div>
            <div className="card">
              <div className="textCol ">
                <h2 style={{ color: '#1A191E', fontSize: 40, fontWeight: 500 }}>Appraisal Setup</h2>
                <p className="pb-4" style={{ color: '#444444', fontSize: 14, lineHeight: '152%' }}>
                  Managers/Team leads of Government MDAs can automatically set appraisal periods either annually or bi-annually which is called the performance appraisal.                </p>
              </div>
              <div className="iconCol">
                <img
                  src={`${srcBase}/bandwidth.webp`}
                  className="img-resize img-fluid"
                />
              </div>
            </div>
          </div>
          <div className="cardContainer">
            <div className="card" >
              <div className="iconCol">
                <img
                  src={`${srcBase}/job.webp`}
                  className="img-resize img-fluid"
                  alt=""
                />
              </div>
              <div className="textCol p-4" style={{}}>
                <h2 style={{ color: '#1A191E', fontSize: 40, fontWeight: 500 }}>Job Schedule Upload</h2>
                <p className=" pb-4" style={{ color: '#444444', fontSize: 14, lineHeight: '152%' }}>
                  The Performance Management tool provides a common platform for different departments, units, and staff to communicate as regards performance management simplifying the process of defining reporting lines.                </p>
              </div>
            </div>
            <div className="card">

              <div className="textCol p-4">
                <h2 style={{ color: '#1A191E', fontSize: 40, fontWeight: 500 }}>Reporting & Transparency</h2>
                <p className="pb-4" style={{ color: '#444444', fontSize: 14, lineHeight: '152%' }}>
                  Employees can now trust Government MDAs since communication, performance, appraisals, and promotions are streamlined and are available on one platform.                 </p>
              </div>
              <div className="iconCol">
                <img
                  src={`${srcBase}/reporting.webp`}
                  className="img-resize img-fluid"

                />
              </div>
            </div>
            <div className="cardio">
            </div>
          </div>
        </div>
      </section>

      <section className="section-two">
        <div className="container mt-5">
          <h2 className="my-3 fw-bold text-center" style={{ fontSize: 48 }}>Why Choose Performance Management?</h2>
          <div className="container">
            <div className="row py-5">
              <div className="col-md-2"></div>
              <div className="col-md-8">
                <div className="row">
                  <div className="col-md-6">
                    <h2 className='fw-bold' style={{ fontSize: 24 }}>Government Transparency</h2>
                    <p className="py-4" style={{ fontSize: 18, width: '80%' }}>
                      By establishing clear performance metrics and goals, government MDAs can provide transparency regarding their objectives and priorities. This clarity enables employees to understand what outcomes their managers are striving to achieve and how progress is evaluated.              </p>
                  </div>
                  <div className="col-md-6">
                    <h2 className='fw-bold' style={{ fontSize: 24 }}>Monitoring and Evaluation</h2>
                    <p className="py-4" style={{ fontSize: 18, width: '80%' }}>
                      Performance Management allows for evidence-based decision-making by providing reliable data and analytics through records management, reporting, and dashboard.               </p>
                  </div>
                </div>
              </div>
              <div className="col-md-2"></div>
            </div>
            <div className="row mt-4">
              <div className="col-md-2"></div>
              <div className="col-md-8">
                <div className="row">
                  <div className="col-md-6">
                    <h2 className='fw-bold' style={{ fontSize: 24 }}>Stakeholder Engagement</h2>
                    <p className="py-4" style={{ fontSize: 18, width: '80%' }}>
                      Performance Management facilitates engagement by providing avenues for feedback and collaboration between managers and employees in the performance management process, thus demonstrating a commitment to transparency and inclusivity.              </p>
                  </div>
                  <div className="col-md-6">
                    <h2 className='fw-bold' style={{ fontSize: 24 }}>Data Accessibility</h2>
                    <p className="py-4" style={{ fontSize: 18, width: '80%' }}>
                      Performance Management makes performance data accessible to the relevant stakeholders for informed decisions.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-2"></div>
            </div>
          </div>
        </div>
      </section>

      <div className="bg-header ">
        <h1 className="header-text-3">Trusted by MDAs, embraced by the public.</h1>
        <div className="body-text-3 text-left mx-auto">
          <h1 className="fw-bolder" style={{fontSize:50}}>“</h1>
          <p>To stay innovative, my team needs to regularly reinvent its skillset. With Performance Management, I can give my team the space to learn and take the initiative. It means we can work at higher pace while staying productive.</p>
          <p className="text-success pt-4 fw-semibold">Priscillia Nejo</p>
        </div>
      </div>







      <div className="container">
        <section className="benefit-section">
          <div className="row" >
            <section className="bottom-section">
              <div className="container">
                <div className="content mx-auto " >
                  <p className="title">Get Started Now</p>
                  <div className=" mx-auto overflow-scroll" style={{width:'65%'}}>
                    <p style={{ fontSize: 18, color: 'rgba(0,0,0,0.6' }}>
                      Eliminate the double standards, favoritism, and Godfathers in Government MDAs with Performance Management.
                    </p>
                  </div>
                  <div className="py-4">
                    <GreenButtonSmall
                      label="Sign up now →"
                      className="cicod-btn-lg"
                      link={'/subscribe'}
                    />
                  </div>

                </div>
              </div>
            </section>
          </div>
        </section>
      </div>

      <style jsx>{style}</style>
    </>
  );
};

const WorkFlowManager = () => {
  return (
    <ProductProvider product={"wfm"}>
      <Page />
    </ProductProvider>
  );
};

WorkFlowManager.getInitialProps = (ctx) => {
  return { hasHeader: true, noPadding: true };
};

export default WorkFlowManager;
